import { safeCustomElement } from '@/utilities/custom-element'
import { MdcDataTable } from '../DataTable/DataTable'

/**
 * @deprecated Use `MdcDataTable` (`mdc-data-table`) instead.
 */
@safeCustomElement('mdc-talent-impact-report-table')
export class MdcTalentImpactReportTable extends MdcDataTable {}
